import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {UiControl} from '../../models/uiControl';
import {map, take, tap} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {SanitizationService} from '../sanitization.service';
import {UiConfigService} from '@lv1871/core';
import {EventService} from '../event.service';
import {AufzaehlungResponse} from '../../models/aufzaehlungResponse';

@Injectable({
  providedIn: 'root'
})
export class AntragsdatenserviceRestService {

  private _trackingId: string;

  constructor(private _http: HttpClient,
              private _sanitizer: SanitizationService, private _uiConfigService: UiConfigService,
              private _eventService: EventService) {
    this._eventService.sessionId$.pipe(take(1)).subscribe(trackingId => this._trackingId = trackingId);
  }

  public postUiControl(body: UiControl): Observable<UiControl> {
    return this._http.post<UiControl>(
        this._uiConfigService.getAntragserfassungUrl() + '/api/produkt/control', this._sanitizer.sanitize(body), {
          // headers,
          observe: 'response'
        }).pipe(
        tap(response => this._eventService.sessionId$.next(response.headers.get('Tracking-ID') ? response.headers.get('Tracking-ID') : this._trackingId)),
        map(response => response.body));
  }

  public getAufzaehlung(aufzaehlungName: string): Observable<AufzaehlungResponse> {
    return this._http.get<AufzaehlungResponse>(this._uiConfigService.getAntragserfassungUrl() + '/api/produkt/aufzaehlung/' + aufzaehlungName);
  }
}
